import api from './api'
import type { Wall, IFCWall } from '../types'

export const wallApi = {
  getWalls: (siteId: string) => api.get<Wall[]>(`/sites/${siteId}/walls`).then((r) => r.data),
  getIFCWalls: (siteId: string) => api.get<IFCWall[]>(`/sites/${siteId}/ifc-walls`).then((r) => r.data),
  createWall: (siteId: string, data: Partial<Wall>) => api.post<Wall>(`/sites/${siteId}/walls`, data).then((r) => r.data),
  updateWall: (siteId: string, id: string, data: Partial<Wall>) => api.patch<Wall>(`/sites/${siteId}/walls/${id}`, data).then((r) => r.data),
  deleteWall: (siteId: string, id: string) => api.delete(`/sites/${siteId}/walls/${id}`),
}
